<div class="manage-status-dialog">
  <div class="question confirm-dialog__question">{{ config.caption }}</div>
  <div class="details confirm-dialog__details">{{ config.detailsText }}</div>

  <div class="status-selector">
    <button
      class="font_label font_label_medium btn badge-status"
      [matMenuTriggerFor]="menuStatus"
      [matTooltip]="currentStatus.hint"
      [ngStyle]="{color: currentStatus.color, background: currentStatus.background}"
      [matTooltipClass]="['rt-default', 'rt-default-tooltip']"
      [matTooltipShowDelay]="1000"
    >
      {{ currentStatus.name.toLocaleLowerCase() }}
      <rt-icon
        class="badge-arrow"
        name="icn_chevron-down"
      />
    </button>

    <mat-menu #menuStatus="matMenu">
      @for (status of config.availableStatuses; track $index) {
        @if (status.availableAsOption) {
          <button
            mat-menu-item
            class="font_body font_body_medium context-menu__button"
            (click)="updateCurrentStatus(status.name)"
          >
            {{ status.name.toLocaleLowerCase() }}
          </button>
        }
      }
    </mat-menu>
  </div>

  <hr class="separator confirm-dialog__separator">

  <div class="controls confirm-dialog__controls">
    <button (click)="closeDialog()" class="button_tertiary_outline  controls__button">
      {{ config.cancel }}
    </button>

    <button (click)="closeDialog(currentStatus.name)" class="button controls__button">{{ config.confirm }}</button>
  </div>
</div>
